import { useEffect, useState } from 'react';

// COMPONENTS
import UnusedTilesGrid from './UnusedTilesGrid';
import ColorPicker from './ColorPicker';

// ICONS
import { ChevronLeft } from 'lucide-react';

export default function Sidebar({ setIsSidebarOpen, unusedTiles = [], onRestore, colorPickerTileId, updateTileColor, tilesState, setTilesState }) {


    useEffect(() => {
        if (window.innerWidth < 768) {
            setTimeout(() => {
                setIsSidebarOpen(false)
            }, 500)
        }
    }, [])

    return (
        <aside className="w-80 h-full flex flex-col fixed z-10">
            {/* Header */}
            <div className="px-2 py-4 flex items-center justify-between">
                {/* Title */}
                <h1 className="text-noir dark:text-blanc text-2xl font-bold ml-6">Mode édition</h1>
                {/* Close sidebar button */}
                <button onClick={() => setIsSidebarOpen(false)} className="p-2 rounded-lg hover:bg-noir/10 dark:hover:bg-gris/40 cursor-pointer">
                    <ChevronLeft size={24} />
                </button>
            </div>

            {colorPickerTileId && (
                <ColorPicker
                    initialColorHex={tilesState.find(t => t.id === colorPickerTileId)?.color}
                    onColorSelected={(selectedColor) => {
                        updateTileColor(colorPickerTileId, selectedColor.TCO_HEXA);
                        setTilesState(prev =>
                            prev.map(tile =>
                                tile.id === colorPickerTileId
                                    ? { ...tile, color: selectedColor.TCO_HEXA, colorId: selectedColor.TCO_ID }
                                    : tile
                            )
                        );
                    }}
                />
            )}

            {/* Menu section */}
            <div className="flex-1 flex flex-col min-h-0 rounded-xl">
                <UnusedTilesGrid unusedTiles={unusedTiles} onRestore={onRestore} />
            </div>
        </aside>
    )
}